import { defineComponent, toRef, computed, createElementBlock, openBlock, createElementVNode, normalizeClass, toDisplayString } from 'vue';

const _hoisted_1 = { class: "nav-main-mobile" };
const _hoisted_2 = { class: "visually-hidden" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NavMobileToggle",
  props: {
    isOpen: { type: Boolean, default: false },
    label: { default: "Menu" }
  },
  emits: ["click"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const isOpen = toRef(props, "isOpen");
    const emit = __emit;
    const onClick = () => {
      emit("click");
    };
    const buttonClassNames = computed(() => ({
      button: true,
      "button--icon-only": true,
      "button--is-closed": !isOpen.value,
      "button--is-opened": isOpen.value
    }));
    const iconClassNames = computed(() => ({
      "menu-icon": true,
      "menu-icon--is-closed": !isOpen.value,
      "menu-icon--is-opened": isOpen.value
    }));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("button", {
          class: normalizeClass(buttonClassNames.value),
          onClick
        }, [
          createElementVNode("span", {
            class: normalizeClass(iconClassNames.value)
          }, null, 2),
          createElementVNode("span", _hoisted_2, toDisplayString(_ctx.label), 1)
        ], 2)
      ]);
    };
  }
});

export { _sfc_main as default };
